/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Test_Export_SuccessInputs */

const en_validation_test_export_success = /** @type {(inputs: Validation_Test_Export_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation results exported successfully`)
};

const nl_validation_test_export_success = /** @type {(inputs: Validation_Test_Export_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validatieresultaten succesvol geëxporteerd`)
};

/**
* | output |
* | --- |
* | "Validation results exported successfully" |
*
* @param {Validation_Test_Export_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_test_export_success = /** @type {((inputs?: Validation_Test_Export_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Test_Export_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_test_export_success(inputs)
	return en_validation_test_export_success(inputs)
});